import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { _vendorAdminRoutes } from "../../utils/appRouter";

const Sidebar = () => {

  const [isExpanded, setIsExpanded] = useState(false);
  const [isLocked, setIsLocked] = useState(false); // track lock state

  const toggleSidebar = () => {
    if (isLocked) {
      // if already locked, unlock and collapse
      setIsLocked(false);
      setIsExpanded(false);
    } else {
      // lock and expand
      setIsLocked(true);
      setIsExpanded(true);
    }
  };

  // 🔑 Add/remove class on body when locked

  useEffect(() => {
    if (isLocked) {
      document.body.classList.add("sidebar-expanded");
    } else {
      document.body.classList.remove("sidebar-expanded");
    }
  }, [isLocked]);

  return (
    <aside
      className={`main-sidebar sidebar-dark-primary ${isExpanded ? "expanded" : "collapsed"
        }`}
      onMouseEnter={() => {
        if (!isLocked) setIsExpanded(true); // expand on hover if not locked
      }}
      onMouseLeave={() => {
        if (!isLocked) setIsExpanded(false); // collapse on hover if not locked
      }}
    >
      <div className="sidebar">
        <div className="navbg">
          <img src="/images/navtopbg.png" alt="/" />
        </div>

        <div className="text-right leftmenuaction">
          {/* Collapse button (force close and unlock) */}
          <button
            className="menucloico closemenu-big"
            onClick={() => {
              setIsExpanded(false);
              setIsLocked(false);
            }}
          >
            <i className="fa fa-arrow-left"></i>
          </button>

          {/* Toggle button */}

          <button
            onClick={toggleSidebar}
            className="menuexpico closemenu-bigopen menu-btn"
          >
            <img src="/images/menu-left-alt.svg" width="25px" alt="toggle" />
          </button>

        </div>

        {/* Sidebar Links */}
        <nav className="scroll-y">
          <ul className="nav nav-pills nav-sidebar flex-column">
            <li className="nav-item">
              <Link to="../vendor-admin/dashboard" className="nav-link">
                <i className="fas fa-chart-line"></i>
                <span className="link-text">Dashboard</span>
              </Link>
            </li>

            {/* <li className="nav-item">
              <Link to="../vendor-admin/Services" className="nav-link">
                <i className="fas fa-shopping-cart"></i>
                <span className="link-text">Services</span>
              </Link>
            </li> */}
            <li className="nav-item">
              <Link to="../vendor-admin/Branches" className="nav-link">
                <i className="fa-solid fa-location-dot"></i>
                <span className="link-text">Branches</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="../vendor-admin/customers" className="nav-link">
                <i className="fa-solid fa-user-plus"></i>
                <span className="link-text">Customers</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="../vendor-admin/orders" className="nav-link">
                <i class="fa-solid fa-list"></i>
                <span className="link-text">Orders</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="../vendor-admin/Staff" className="nav-link">
                <i className="fa-solid fa-user-plus"></i>
                <span className="link-text">Staff</span>
              </Link>
            </li>
            {/* <li className="nav-item">
              <Link to="../vendor-admin/Offers" className="nav-link">
                <i className="fa-solid fa-percent" aria-hidden="true"></i>
                <span className="link-text">Offers</span>
              </Link>
            </li> */}
            <li className="nav-item">
              <Link to="../vendor-admin/Financials" className="nav-link">
                <i className="fa-solid fa-wallet"></i>
                <span className="link-text">Financials</span>
              </Link>
            </li>

            <li className="nav-item">
              <Link to="../vendor-admin/Reviews" className="nav-link">
                <i className="fa-solid fa-star"></i>
                <span className="link-text">Reviews</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="../vendor-admin/Complaints" className="nav-link">
                <i className="fa-solid fa-circle-info"></i>
                <span className="link-text">Complain</span>
              </Link>
            </li>
             <li className="nav-item">
              <Link to="../vendor-admin/coupon" className="nav-link">
                <i className="fa-solid fa-ticket"></i>
                <span className="link-text">Coupons </span>
              </Link>
            </li>
            {/* <li className="nav-item">
              <Link to="#" className="nav-link">
                <i className="fa-solid fa-image"></i>
                <span className="link-text">Showcase</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="#" className="nav-link">
                <i className="fa-solid fa-chart-line"></i>
                <span className="link-text">Reports</span>
              </Link>
            </li> */}
          </ul>
        </nav>
      </div>
    </aside>
  );
};

export default Sidebar;
